// columnDefs.js
export const duplicateColumnDefs = [
  { headerName: "S.NO", valueGetter: (params) => params.node.rowIndex + 1 },
  { headerName: "Donor ID", field: "ID" },
  { headerName: "Book No", field: "BookNo", filter: "agTextColumnFilter" },
  {
    headerName: "Receipt No",
    field: "ReceiptNo",
    filter: "agTextColumnFilter",
  },
  {
    headerName: "Receipt Date",
    field: "ReceiptDate",
    filter: "agTextColumnFilter",
  },
  { headerName: "Pay Mode", field: "PayMode", filter: "agTextColumnFilter" },
  { headerName: "Amount", field: "Amount", filter: "agTextColumnFilter" },
  { headerName: "Bank Name", field: "BankName", filter: "agTextColumnFilter" },
  {
    headerName: "Instrument No",
    field: "InstrumentNo",
    filter: "agTextColumnFilter",
  },
  {
    headerName: "Instrument Date",
    field: "InstrumentDate",
    filter: "agTextColumnFilter",
  },
  {
    headerName: "Pay Purpose",
    field: "PayPurpose",
    filter: "agTextColumnFilter",
  },
  { headerName: "Mobile1", field: "Mobile1", filter: "agTextColumnFilter" },
  { headerName: "Status", field: "Status", filter: "agTextColumnFilter" },
  {
    headerName: "Remarks",
    field: "Remarks",
    cellStyle: (params) => {
      if (params.value?.includes("Error List")) {
        return { color: "red", fontWeight: "bold" };
      }
      if (params.value?.includes("Informative List")) {
        return { color: "orange", fontWeight: "bold" };
      }
      return null;
    },
    filter: "agTextColumnFilter",
  },
];

export const duplicateDonorColumnDefs = [
  {
    headerName: "S.NO",
    valueGetter: (params) => params.node.rowIndex + 1,
  },
  { headerName: "Donor Name", field: "Name", filter: "agTextColumnFilter" },
  { headerName: "Address", field: "Address", filter: "agTextColumnFilter" },
  { headerName: "Address1", field: "Address1", filter: "agTextColumnFilter" },
  { headerName: "City", field: "City", filter: "agTextColumnFilter" },
  { headerName: "Pincode", field: "Pincode", filter: "agTextColumnFilter" },
  { headerName: "Mobile1", field: "Mobile1", filter: "agTextColumnFilter" },
  { headerName: "Book No", field: "BookNo", filter: "agTextColumnFilter" },
  {
    headerName: "Receipt No",
    field: "ReceiptNo",
    filter: "agTextColumnFilter",
  },
  {
    headerName: "Receipt Date",
    field: "ReceiptDate",
    filter: "agTextColumnFilter",
  },
  { headerName: "Amount", field: "Amount", filter: "agTextColumnFilter" },
  { headerName: "Pay Mode", field: "PayMode", filter: "agTextColumnFilter" },
  { headerName: "Bank Name", field: "BankName", filter: "agTextColumnFilter" },
  {
    headerName: "Instrument No",
    field: "InstrumentNo",
    filter: "agTextColumnFilter",
  },
  {
    headerName: "Instrument Date",
    field: "InstrumentDate",
    filter: "agTextColumnFilter",
  },
  {
    headerName: "Pay Purpose",
    field: "PayPurpose",
    filter: "agTextColumnFilter",
  },
  { headerName: "Status", field: "Status", filter: "agTextColumnFilter" },
  {
    headerName: "Remarks",
    field: "Remarks",
    cellStyle: (params) => {
      if (params.value?.includes("Error List")) {
        return { color: "red", fontWeight: "bold" };
      }
      if (params.value?.includes("Informative List")) {
        return { color: "orange", fontWeight: "bold" };
      }
      return null;
    },
    filter: "agTextColumnFilter",
  },
];

export const DonorIdMissingColumnDefs = [
  {
    headerName: "S.NO",
    valueGetter: (params) => params.node.rowIndex + 1,
  },
  {
    headerName: "Excel Row Index",
    field: "index",
    filter: "agTextColumnFilter",
  },
  { headerName: "Donor ID", field: "ID", filter: "agTextColumnFilter" },
  { headerName: "Book No", field: "BookNo", filter: "agTextColumnFilter" },
  {
    headerName: "Receipt No",
    field: "ReceiptNo",
    filter: "agTextColumnFilter",
  },
  {
    headerName: "Receipt Date",
    field: "ReceiptDate",
    filter: "agTextColumnFilter",
  },
  { headerName: "Pay Mode", field: "PayMode", filter: "agTextColumnFilter" },
  { headerName: "Amount", field: "Amount", filter: "agTextColumnFilter" },
  { headerName: "Bank Name", field: "BankName", filter: "agTextColumnFilter" },
  {
    headerName: "Instrument No",
    field: "InstrumentNo",
    filter: "agTextColumnFilter",
  },
  {
    headerName: "Instrument Date",
    field: "InstrumentDate",
    filter: "agTextColumnFilter",
  },
  {
    headerName: "Pay Purpose",
    field: "PayPurpose",
    filter: "agTextColumnFilter",
  },
  { headerName: "Mobile1", field: "Mobile1", filter: "agTextColumnFilter" },
  { headerName: "Remarks", field: "Remarks", filter: "agTextColumnFilter" },
];

export const DonorFieldMisingColumnDefs = [
  {
    headerName: "S.NO",
    valueGetter: (params) => params.node.rowIndex + 1,
  },
  {
    headerName: "Excel Row Index",
    field: "index",
    filter: "agTextColumnFilter",
  },
  { headerName: "Donor Name", field: "Name", filter: "agTextColumnFilter" },
  { headerName: "Address", field: "Address", filter: "agTextColumnFilter" },
  { headerName: "Address1", field: "Address1", filter: "agTextColumnFilter" },
  { headerName: "City", field: "City", filter: "agTextColumnFilter" },
  { headerName: "Pincode", field: "Pincode", filter: "agTextColumnFilter" },
  { headerName: "Mobile1", field: "Mobile1", filter: "agTextColumnFilter" },
  { headerName: "Book No", field: "BookNo", filter: "agTextColumnFilter" },
  {
    headerName: "Receipt No",
    field: "ReceiptNo",
    filter: "agTextColumnFilter",
  },
  { headerName: "Pay Mode", field: "PayMode", filter: "agTextColumnFilter" },
  {
    headerName: "Receipt Date",
    field: "ReceiptDate",
    filter: "agTextColumnFilter",
  },
  { headerName: "Amount", field: "Amount", filter: "agTextColumnFilter" },
  { headerName: "Bank Name", field: "BankName", filter: "agTextColumnFilter" },
  {
    headerName: "Instrument No",
    field: "InstrumentNo",
    filter: "agTextColumnFilter",
  },
  {
    headerName: "Instrument Date",
    field: "InstrumentDate",
    filter: "agTextColumnFilter",
  },
  {
    headerName: "Pay Purpose",
    field: "PayPurpose",
    filter: "agTextColumnFilter",
  },
  {
    headerName: "Remarks",
    field: "Remarks",
    cellStyle: (params) => {
      if (params.value?.includes("Error List")) {
        return { color: "red", fontWeight: "bold" };
      }
      if (params.value?.includes("Informative List")) {
        return { color: "orange", fontWeight: "bold" };
      }
      return null;
    },
    filter: "agTextColumnFilter",
  },
];

export const prasadErrorColumnDefs = [
  { headerName: "S.NO", field: "index", width: 80 },
  { headerName: "Donor ID", field: "donorId", flex: 1 },
  { headerName: "Remarks", field: "remarks", flex: 2 },
];
export const ValidationErrorColumnDefs = [
  { field: "index", headerName: "Excel Row Index", width: 150 },
  { field: "ID", headerName: "Donor ID", width: 120 },
  { field: "BookNo", headerName: "Book No", width: 120 },
  { field: "ReceiptNo", headerName: "Receipt No", width: 130 },
  { field: "Remarks", headerName: "Remarks", flex: 1, wrapText: true, autoHeight: true },
];

